import { settings } from '../store/settings.js';

/**
 * A short haptic pulse for a positive action (catch, favorite…). Gated on
 * the user's haptics setting and on Vibration API support — most notably
 * absent on iOS Safari, where this silently does nothing.
 */
export function buzz(pattern = 15) {
  if (!settings.get().haptics || !navigator.vibrate) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    /* unsupported in this context (e.g. no user-activation) — ignore */
  }
}
